var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup37811(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#EF4D92"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_41",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1583 13.8855L16.9145 7.15737L15.5729 5.82129L10.1583 11.2133L7.42704 8.49345L6.08538 9.82953L10.1583 13.8855ZM11.5 19.0389C10.1743 19.0389 8.92843 18.7883 7.76246 18.2869C6.59649 17.7862 5.58225 17.1064 4.71975 16.2475C3.85725 15.3886 3.1746 14.3786 2.67179 13.2174C2.16835 12.0563 1.91663 10.8157 1.91663 9.49551C1.91663 8.17533 2.16835 6.93469 2.67179 5.77357C3.1746 4.61245 3.85725 3.60244 4.71975 2.74353C5.58225 1.88462 6.59649 1.20449 7.76246 0.703141C8.92843 0.202428 10.1743 -0.0479279 11.5 -0.0479279C12.8257 -0.0479279 14.0715 0.202428 15.2375 0.703141C16.4034 1.20449 17.4177 1.88462 18.2802 2.74353C19.1427 3.60244 19.8253 4.61245 20.3281 5.77357C20.8316 6.93469 21.0833 8.17533 21.0833 9.49551C21.0833 10.8157 20.8316 12.0563 20.3281 13.2174C19.8253 14.3786 19.1427 15.3886 18.2802 16.2475C17.4177 17.1064 16.4034 17.7862 15.2375 18.2869C14.0715 18.7883 12.8257 19.0389 11.5 19.0389ZM11.5 17.1303C13.6402 17.1303 15.4531 16.3906 16.9385 14.9114C18.4239 13.4322 19.1666 11.6269 19.1666 9.49551C19.1666 7.36414 18.4239 5.55884 16.9385 4.07961C15.4531 2.60038 13.6402 1.86076 11.5 1.86076C9.35968 1.86076 7.54683 2.60038 6.06142 4.07961C4.576 5.55884 3.83329 7.36414 3.83329 9.49551C3.83329 11.6269 4.576 13.4322 6.06142 14.9114C7.54683 16.3906 9.35968 17.1303 11.5 17.1303Z",
    fill: "#FFFBF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup37811);
export default __webpack_public_path__ + "static/media/Group 37811.24949cd4b37d3cbccfd7b987d653cf96.svg";
export { ForwardRef as ReactComponent };